import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const UserRoutes: RouteRecordRaw = {
  path: '/user',
  name: 'UserModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageUsersRoute',
      component: () => import('./views/ManageUsersView.vue'),
      meta: {
        title: 'کاربران',
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.user,
  },
}

export default (router: Router) => {
  router.addRoute(UserRoutes)
}
